/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ amount: NonNullable<unknown> }} Partner_Add_Contract_Prepaid_Below_PlanInputs */



/**
* | output |
* | --- |
* | "Lower than the {amount} these seats would earn on the plan itself — check the amount." |
*
* @param {Partner_Add_Contract_Prepaid_Below_PlanInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const partner_add_contract_prepaid_below_plan = /** @type {((inputs: Partner_Add_Contract_Prepaid_Below_PlanInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Partner_Add_Contract_Prepaid_Below_PlanInputs, { locale?: "en" | "de" }, {}>} */ ((i, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ (`Niedriger als die ${i?.amount}, die diese Plätze im Tarif selbst erhalten würden — bitte den Betrag prüfen.`)
	return /** @type {LocalizedString} */ (`Lower than the ${i?.amount} these seats would earn on the plan itself — check the amount.`)
});